import PageContainer from '@/common/components/PageContainer'
import ContactBankSettingListing from '@/modules/client-setting/components/ContactBankSetting/components/ContactBankSettingListing'
import Spinner from '@/common/components/Spinner'
import useQueryGetGeneralSetting from '@/modules/client-setting/api/hooks/useQueryGetGeneralSetting'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function ContactBankSettingPage() {
	const { data: generalSetting, isLoading } = useQueryGetGeneralSetting()

	if (isLoading || !generalSetting) {
		return <Spinner />
	}

	return (
		<PageContainer>
			<ContactBankSettingListing data={generalSetting} />
		</PageContainer>
	)
}

const GuardedContactBankSettingPage = withUserPermission(
	ContactBankSettingPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.WEB_SETTING],
	},
)

export default GuardedContactBankSettingPage
